import './CompanyPreviewCard.scss';

import React from 'react';
import { cn } from '../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Picture } from '@dataartdev/uikit/Picture';
import { Item } from '../ContentBuilder/templates/models/CTI_75.props';
import { Button } from '@dataartdev/uikit/Button';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';

export const cnCompanyPreviewCard = cn('CompanyPreviewCard');

export const CompanyPreviewCard: React.FC<Item> = props => {
  const { title, text, link, icon } = props || {};
  const isLink = !!link?.link;

  return (
    <div className={cnCompanyPreviewCard({ isLink: isLink })}>
      {icon && (
        <div className={cnCompanyPreviewCard('Icon')}>
          <Picture {...icon} />
        </div>
      )}
      <div className={cnCompanyPreviewCard('Inner')}>
        <div className={cnCompanyPreviewCard('Top')}>
          {title && (
            <Typography.Title
              as="h3"
              size="md"
              className={cnCompanyPreviewCard('Title')}
            >
              {title}
            </Typography.Title>
          )}
          {text && (
            <Typography.Text
              as="p"
              size="m"
              className={cnCompanyPreviewCard('Text')}
            >
              {text}
            </Typography.Text>
          )}
        </div>
        {link?.link && (
          <Button
            view="link-secondary"
            iconRight={IconArrowRight}
            iconSize="m"
            label={link?.title}
            as="a"
            href={link?.link}
            className={cnCompanyPreviewCard('Link')}
          />
        )}
      </div>
    </div>
  );
};
